import { createSelector } from 'reselect'
import { RootState } from 'store'

const selectNotificationState = (state: RootState) => state.notification

const selectNotification = createSelector(selectNotificationState, (state) => state.data)
export default {
  selectNotification,
}
